import { Component, OnInit, Injector } from '@angular/core';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';
import { ListTrackingService } from '../common-theme/utils/list-tracking.service';
import { EmbedVideoService } from '../common-theme/index';

@Component({
  selector: 'app-construction',
  templateUrl: './construction.component.html',
  styleUrls: ['./construction.component.scss']
})

export class ConstructionComponent extends SeoAwareBaseComponent implements OnInit {
  public images1: any[] = [];
  public images2: any[] = [];
  public images3: any[] = [];

  videos: any[] = [
    'https://www.youtube.com/watch?v=gSnMwYOvABg'
  ]

  constructor(
    public embedService: EmbedVideoService,
    public listTrackingService: ListTrackingService,
    public injector: Injector
  ) {
    super(injector);

    this.videos = this.videos.map(url => this.embedService.embed(url));
    this.images1 = Array.from(Array(6).keys()).map(el => {
      return {
        url: `/assets/images/gallery/construction/1/${el + 1}.jpg`,
        width_560_url: `/assets/images/gallery/construction/1/${el + 1}.jpg`,
        width_320_url: `/assets/images/gallery/construction/1/${el + 1}.jpg`
      }
    });
    this.images2 = Array.from(Array(20).keys()).map(el => {
      return {
        url: `/assets/images/gallery/construction/2/${el + 1}.jpeg`,
        width_560_url: `/assets/images/gallery/construction/2/${el + 1}.jpeg`,
        width_320_url: `/assets/images/gallery/construction/2/${el + 1}.jpeg`
      }
    }).reverse();
    this.images3 = Array.from(Array(13).keys()).map(el => {
      return {
        url: `/assets/images/gallery/construction/3/${el + 1}.jpg`,
        width_560_url: `/assets/images/gallery/construction/3/${el + 1}.jpg`,
        width_320_url: `/assets/images/gallery/construction/3/${el + 1}.jpg`
      }
    }).reverse();
  }

  ngOnInit(): void {
    this.setTitle('Șantierul Romanescu Park Residence');
  }
}



// WEBPACK FOOTER //
// ./src/app/downtown-life/construction.component.ts